import moment from 'moment';
import calculArrondi from '@/services/calcul/calculArrondi';

export function getExtremeDate(dates, mode = 'min') {
  if (!Array.isArray(dates) || (mode !== 'min' && mode !== 'max')) {
    return null;
  }

  const validMoments = dates
    .filter(d => d != null)
    .map(d => moment(d))
    .filter(m => m.isValid());

  if (validMoments.length === 0) return null;
  return mode === 'min'
    ? moment.min(validMoments)
    : moment.max(validMoments);
}

export function calculerRemiseBudget(budget) {
  const { prixBrutNegocie, prixNet } = budget;
  if (!Number.isFinite(prixBrutNegocie)
    || !Number.isFinite(prixNet)
    || prixBrutNegocie <= 0
  ) return null;

  const remise = ((prixBrutNegocie - prixNet) / prixBrutNegocie) * 100;
  return -1 * calculArrondi(remise, 5);
}

export function calculerPrixBrut(prixNet, remise) {
  if (!Number.isFinite(prixNet) || !Number.isFinite(remise) || prixNet <= 0) return null;
  const result = prixNet / (1 - (-1 * remise / 100));
  return calculArrondi(result);
}

export function calculerNbreAnnees(dateDebut, dateFin) {
  const debut = moment(dateDebut);
  const fin = moment(dateFin);
  if (!debut.isValid() || !fin.isValid() || fin.isBefore(debut)) return null;
  fin.add(1, 'd');
  const res = fin.diff(debut, 'y', true);
  return res;
}

export function calcProrata(val, dateDebut, dateFin) {
  if (!val) return null;
  const nbrAnnee = calculerNbreAnnees(dateDebut, dateFin);
  if (!nbrAnnee) return null;
  if (nbrAnnee > 1) return val;
  return calculArrondi(val * nbrAnnee);
}

export function trierParDateDebut(lignes) {
  if (!Array.isArray(lignes)) {
    return [];
  }

  return [...lignes].sort((a, b) => {
    const da = moment(a.dateDebut);
    const db = moment(b.dateDebut);

    const va = da.isValid();
    const vb = db.isValid();

    if (!va && !vb) return 0;
    if (!va) return 1;   // dates invalides à la fin
    if (!vb) return -1;

    return da.valueOf() - db.valueOf();
  });
}

export function calculMontantAvecRemise(montant, quantite, remise) {
  const totalAvantRemise = calculArrondi(montant * quantite);
  return calculArrondi(totalAvantRemise + totalAvantRemise * remise / 100);
}

export function finPeriodeBudgetaire(date, moisDebut) {
  const d = moment(date).startOf('day');
  const debutPeriode = moment({ year: d.year(), month: moisDebut - 1, day: 1 }).startOf('day');
  if (debutPeriode.isAfter(d)) {
    debutPeriode.subtract(1, 'year');
  }
  return debutPeriode.add(1, 'year').subtract(1, 'day');
}

export function moisDebutPdv(pointDeVente) {
  const enseigne = pointDeVente && pointDeVente.tiersParent;
  const moisDebut = enseigne && enseigne.moisDebutPeriodeBudgetaire;
  const moisFin = enseigne && enseigne.moisFinPeriodeBudgetaire;
  return (moisDebut && moisFin) ? moisDebut : null;
}

export function calculerDateFinPremiereEcheance(dateDebut, dateFin, pointDeVente = null) {
  if (!dateDebut || !dateFin) return null;
  const debut = moment(dateDebut).startOf('day');
  const moisDebut = moisDebutPdv(pointDeVente);
  const finPremiereEcheance = moisDebut
    ? finPeriodeBudgetaire(debut, moisDebut)
    : debut.clone().endOf('year').startOf('day');

  if (finPremiereEcheance.isSameOrAfter(moment(dateFin).startOf('day'))) return null;
  return finPremiereEcheance.toDate();
}

export function calculerDateFinBudgetaire(dateDebut, dateFinActuelle, pointDeVente = null) {
  if (!dateDebut) return dateFinActuelle;
  const moisDebut = moisDebutPdv(pointDeVente);
  if (!moisDebut) return dateFinActuelle;

  const cible = moment(dateDebut).startOf('day').add(1, 'year');
  return finPeriodeBudgetaire(cible, moisDebut).toDate();
}

export function getMinDate(dates) {
  if (!Array.isArray(dates)) return null;

  const validMoments = dates
    .filter(d => d !== null && d !== undefined)
    .map(d => moment(d))
    .filter(m => m.isValid());

  if (validMoments.length === 0) return null;

  return moment.min(validMoments).toDate();
}
